import { FontVariant } from "../../constants/fonts";
import FontSelection from "./FontSelection";

export default function FontConfiguration() {
  return (
    <div>
      <FontSelection
        label="Primary - Bold"
        fontVariantName={FontVariant.PrimaryBold}
      />
      <FontSelection
        label="Primary - Regular"
        fontVariantName={FontVariant.PrimaryRegular}
      />
      <FontSelection
        label="Primary - Thin"
        fontVariantName={FontVariant.PrimaryThin}
      />
      <FontSelection
        label="Secondary - Bold"
        fontVariantName={FontVariant.SecondaryBold}
      />
      <FontSelection
        label="Secondary - Regular"
        fontVariantName={FontVariant.SecondaryRegular}
      />
      <FontSelection
        label="Secondary - Thin"
        fontVariantName={FontVariant.SecondaryThin}
      />
    </div>
  );
}
